module.exports = __webpack_public_path__ + "img/UT_Tech.0d93e32f.png";